import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { ProjectChangesDateLogList } from '../../../domain/projectChangesDateLog/ProjectChangesDateLogList';
import { ProjectChangesDateLog } from '../../../domain/projectChangesDateLog/projectChangesDateLog';
import { ProjectCheckpointsList } from '../../../domain/projectCheckpoints/projectCheckpointList';
import { Project } from '../../../domain/projects/project';
import { ProjectCheckpointsRepository } from '../../../infrastructure/repositories/projectCheckpoints/projectCheckpointsRepository';
import { ProjectsRepository } from '../../../infrastructure/repositories/projects/projectRepository';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import Section from '../components/projectOverview/Section';
import { ProjectLicenseList } from '../../../domain/projectLicenses/ProjectLicenseList';
import { LicensesRepository } from '../../../infrastructure/repositories/licenses/LicencesRepository';

export const ProjectOverviewPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Proyectos');
    const [project, setProject] = useState<Project>();
    const [projectCheckpoints, setprojectCheckpoints] =
        useState<ProjectCheckpointsList[]>();
    const [projectChangesDateLog, setProjectChangesDateLog] =
        useState<ProjectChangesDateLogList[]>();
    const [projectChanges, setProjectChanges] = useState<ProjectChangesDateLog>();
    const [projectLicenses, setProjectLicenses] = useState<ProjectLicenseList[]>();

    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Proyectos',
                route: Private_Routes.PROJECT_PAGE,
            },
            {
                label: project?.name ?? 'Detalles',
                route: `/projects/projects-list/${id}`,
            },
        ]);
    }, [lang]);

    useEffect(() => {
        if (id) {
            ProjectsRepository.GetProject(id).then((response) => {
                setProject(response);
            });
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            ProjectCheckpointsRepository.GetProjectCheckpointsList(id).then(
                (response) => {
                    setprojectCheckpoints(response);
                }
            );
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            LicensesRepository.GetProjectsLicensesList(id).then(
                (response) => {
                    setProjectLicenses(response);
                }
            );
        }
    }, [id]);
    return (
        <React.Fragment>
            <div className='pt-2'>
                <Container fluid>
                    <Section
                        project={project}
                        projectCheckpoints={projectCheckpoints}
                        projectChangesDateLogList={projectChangesDateLog}
                        projectChanges={projectChanges}
                        projectLicenses={projectLicenses}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};
